import { api } from './client';

export interface PowerActionResult {
  scheduled: boolean;
  delay_minutes: number;
}

export const postReboot = (): Promise<PowerActionResult> =>
  api.post<PowerActionResult>('/server/reboot').then((r) => r.data);

export const postShutdown = (): Promise<PowerActionResult> =>
  api.post<PowerActionResult>('/server/shutdown').then((r) => r.data);
